import { useQuery } from "@tanstack/react-query";
import { fetchTasks } from "../services/api";

export const useLessonData = (lessonId: number) => {
  return useQuery({
    queryKey: ['lessonData', lessonId],
    enabled: !!lessonId,
    queryFn: async () => {
      if (!lessonId) return null;

      const response = await fetchTasks(lessonId);

      if (!response?.tasks || !response?.titles) {
        throw new Error('Response missing expected data');
      }

      const sortedTasks = response.tasks
        .map((task: any, index: number) => ({
          ...task,
          taskOrder: task.taskOrder ?? index,
        }))
        .sort((a: any, b: any) => a.taskOrder - b.taskOrder);

      return {
        lessonPlanParts: sortedTasks,
        titles: response.titles,
      };
    },
  });
};